module.exports = __webpack_public_path__ + "static/media/  (39).a805f472.jpg";